import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Customers',
    title_cabang: 'Cabang Perusahaan Customers',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Customers',
        href: '/adm/opr/customers',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    items_cabang: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_customer',
    sortDesc: true,
    fields: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
      {
        key: 'npwp',
        label: 'NPWP',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      code: '',
      company: '',
      address: '',
      address_faktur: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
    },
    form_cabang: {
      id_customer: '',
      company_cabang: '',
      nitku_cabang: '',
      alamat_cabang: '',
      telepon_cabang: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_cabang(state) {
    return state.data.form_cabang;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeCustomer(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCustomer(context, params = null) {
    let result = await ApiGetRequest(`opr/customers`, params);
    return !result.error ? result.data.object : [];
  },

  async searchCustomerCabang(context, params = null) {
    let result = await ApiGetRequest(`opr/customers-cabang`, params);
    return !result.error ? result.data.object : [];
  },

  async getCodeCustomer(context, params = null) {
    let result = await ApiGetRequest(`opr/customers/last-code`, params);
    return !result.error ? result.data.object : '';
  },

  async getListCustomerCabang({ commit }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/customers/${payload.id || ''}/cabang`
    );
    commit('changeCustomer', {
      items_cabang: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListCustomer({ commit, state }) {
    commit('changeCustomer', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/customers`, params);
    commit('changeCustomer', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailCustomer({ commit }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/customers/${payload.id}`);
    commit('changeCustomer', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeCustomer', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/customers/import`, {
      items: data.import_form || [],
    });

    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createCustomerCabang({ commit, state, dispatch }) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/customers-cabang`,
      state.data.form_cabang
    );
    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomerCabang({ commit, state, dispatch }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/customers-cabang/${payload.id}`,
      state.data.form_cabang
    );

    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomerCabang({ commit, dispatch }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/customers-cabang/${payload.id}`);
    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async createCustomer({ commit, state, dispatch }) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/customers`, state.data.form);
    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomer({ commit, state, dispatch }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/customers/${payload.id}`,
      state.data.form
    );

    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomer({ commit, dispatch }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/customers/${payload.id}`);
    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
